var PePsBlockView={
  Pe:undefined,
  Ps:1,
  Bvs:2,
  Cfs:3,
  Fcfs:4,
  Div:5
}
export default PePsBlockView;
